/**
 * api接口统一管理
 */
import request, { get, post, upLoad, imgCode, del, put } from "./http";

//=====================================用户模块=====================================================================
//用户注册 register
export const user_register = obj => post("api/client/member/register", obj);

//注册发送短信 register/spend_sms
export const user_register_spend_sms = obj =>
  post("/user/register/spend_sms", obj);

//用户登录 login
export const user_login = obj => post("api/client/auth/login", obj);
// 验证码
export const getCodeImg = data => get("api/client/auth/captcha", data);
// 退出登录
export const user_logout = data => get("api/client/auth/logout", data);
// 菜单
export const getMenu = data => get("api/client/auth/node", data);
// 收藏
export const collect = obj => post("api/client/product/collect", obj);

// 客户信息
export const getUserInfo = data => get("api/client/auth/getMe", data);
// 产品分类
export const getProductClassify = data =>
  get("api/client/product_classify", data);
// 产品列表
export const getProduct = data => get("api/client/product", data);
// 产品详情
export const getProductDetail = data =>
  get("api/client/product/detail/" + data.id);
// 购物车列表
export const getCartList = data => get("api/client/order/cart", data);
// 添加购物车
export const addCart = data => post("api/client/order/cart", data);

// 删除购物车
export const removeCart = data => del("api/client/order/cart", data);

// 编辑购物车
export const editCart = data => put("api/client/order/cart/" + data.id, data);
// 下单
export const submit = data => post("api/client/order/submit", data);
// 预支付
export const advance_submit = data =>
  post("api/client/order/advance_submit", data);
// 支付方式
export const pay_method = data => get("api/client/order/pay_method", data);
// 支付宝支付
export const alipay_submit = data =>
  post("api/client/order/alipay_submit", data);
// 余额支付
export const balance_submit = data =>
  post("api/client/order/balance_submit", data);
// 支付宝充值
export const alipay_recharge = data =>
  post("api/client/order/alipay_recharge", data);
// 微信充值
export const weixin_recharge = data =>
  post("api/client/order/weixin_recharge", data);
// 支付情况查询
export const order_pay_info = data =>
  post("api/client/order/order_pay_info", data);

// 建模支付情况查询
export const develop_pay_info = data => get("api/client/develop/order_pay_info", data);
// 建模余额支付
export const develop_balance_submit = data =>
  post("api/client/develop/balance_submit", data);
// 建模预支付
export const develop_advance_submit = data =>
  post("api/client/develop/advance_submit", data);
// 建模支付方式
export const develop_pay_method = data => get("api/client/develop/pay_method", data);
// 订单列表
export const list_order = data => get("api/client/order/list_order", data);
// 合并订单列表
export const merge_order = data => get("api/client/order/merge_order", data);
// 合并订单
export const merge_pay = data => post("api/client/order/merge_pay", data);
// 取消订单
export const order_cancel = data => put("api/client/order/order_cancel", data);
// 丢弃订单
export const order_delete = data => del("api/client/order/order", data);
// 订单json
export const order_json_detail = id =>
  get("api/client/order/order_json_detail/" + id);
// 物流信息
export const getTracking = id => get("api/client/order/tracking/" + id);
// 属性查看
export const order_detail = id => get("api/client/order/order_detail/" + id);
// 属性编辑
export const order_detail_edit = data =>
  put("api/client/order/order_detail/" + data.id, data);
// 首页轮播图
export const getSlideList = data => get("api/client/index/slideshow", data);
// 其他数据
export const getOtherData = data => get("api/client/index/other", data);
// 国家数据
export const getCountry = data => get("api/client/order/country", data);
// 快递列表
export const getDelivery = data => get("api/client/order/delivery", data);
// 公共菜单
export const publicMenu = data => get("api/client/index/publicMenu", data);
// general
export const list_general = data => get("api/client/order/list_general", data);
// 导入订单
export const singleUpload = data => post("api/client/order/import", data);
// 导入ETSY订单
export const singleUploadETSY = data =>
  post("api/client/order/import_etsy", data);
// 导入马帮订单
export const singleUploadMB = data =>
  post("api/client/order/import_mabang", data);
// 導入內部模板
export const singleUploadInside = data =>
  post("api/client/order/import_internal", data);
export const singleUploadDevelop = data => post("api/client/develop/import", data);
// 获取资讯
export const getNews = data => get("api/client/index/news", data);
// 获取推荐产品
export const recommend = data => get("api/client/product/recommend", data);
// 获取文章分类
export const newsCategory = data => get("api/client/index/newsCategory", data);
// 获取文章列表
export const newsList = data => get("api/client/index/newsList", data);
// sku关联列表
export const skuList = data => get("api/client/product/sku", data);
// 订单关联sku/重新关联sku
export const order_relevance_sku = data =>
  post("api/client/product/order_relevance_sku", data);
// 导入sku
export const skuUpload = data =>
  post("api/client/product/import_tag_code", data);
// 添加sku
export const addSku = data => post("api/client/product/sku", data);
// 编辑sku
export const editSku = data =>
  put("api/client/product/sku/" + data.product_id, data);
// 删除sku
export const delSku = data => del("api/client/product/sku_product", data);
// 删除sku 成品id
export const delSkuCode = data => del("api/client/product/sku_tag", data);
// 删除sku sku
export const delSkuItem = data => del("api/client/product/sku", data);
// 计算成品id
export const calc_tag_code = data =>
  post("api/client/product/calc_tag_code", data);
// 订单地址编辑
export const address = data => put("api/client/order/address/" + data.id, data);
// 订单列表编辑确认
export const editor_submit = data =>
  post("api/client/order/editor_submit", data);
// 个人中心统计数据
export const statisticSale = data => get("api/client/self/statisticSale", data);
// 个人信息
export const self = data => get("api/client/self", data);
// 流水
export const stream = data => get("api/client/self/stream", data);
// 流水general
export const self_general = data => get("api/client/self/general", data);
// 地址快速选择
export const fast_address = data => get("api/client/order/fast_address", data);
// 工单列表
export const workorderGeneral = data =>
  get("api/client/workorder/general", data);
// 工单列表
export const workorder = data => get("api/client/workorder", data);
// 新增工单
export const addWorkorder = data => post("api/client/workorder", data);
// 回复工单
export const reply_work = data => post("api/client/workorder/reply", data);
// 工单详情
export const detail_work = id => get("api/client/workorder/" + id);

// 建模列表
export const general_develop = data => get("api/client/develop/general", data);
export const develop = data => get("api/client/develop", data);
// 新增建模
export const addDevelop = data => post("api/client/develop", data);
// 回复建模
export const reply_develop = data => post("api/client/develop/reply", data);
// 建模详情
export const detail_develop = id => get("api/client/develop/" + id);
// 建模按钮
export const stateButton = data => get("api/trade/develop/stateButton", data);
// 建模页面
export const stateButtonPage = data => get("api/trade/develop/stateButtonPage", data);
// 建模提交
export const stateButtonOperate = data => post("api/trade/develop/stateButtonOperate", data);

// 新品
export const hot_sale_product = data =>
  get("api/client/product/hot_sale_product", data);
// 站内信
export const message = data => get("api/client/message", data);
export const setRead = data => put("api/client/message/customUpdate", data);
export const timingGetMessage = data =>
  get("api/client/message/timingGetMessage", data);
// 上传图片
export const singleUploadImage = data =>
  post("api/basic/wind/singleUpload", data);
// 购物车图片
export const saveImage = data => post("api/client/order/cart/cartAnnex", data);
export const delImage = data => post("api/basic/wind/singleUpload", data);
// 备注
export const editRemark = data => post("api/client/order/edit_remark ", data);
export function downloadFile(
  url,
  data,
  fileName,
  method = "post",
  params = {}
) {
  // 响应类型：arraybuffer, blob
  return new Promise((r, j) => {
    request({
      url,
      data,
      method,
      params,
      responseType: "arraybuffer",
      headers: {
        "xxx-type": "download"
        // 'type': 'application/octet-stream,charset=UTF-8'
      }
    })
      .then(resp => {
        console.log(resp);
        if (!resp) {
          return false;
        } else if (resp.data.status && resp.data.status == 2) {
          console.log(resp.data);
          return resp.data;
        } else {
          try {
            let enc = new TextDecoder("utf-8");
            let data = JSON.parse(enc.decode(new Uint8Array(resp.data)));
            eventBus.$emit("closeMask");
            Notification({
              message: data.msg || "操作失败",
              type: "error",
              duration: 5 * 1000
            });
            console.log("error");
            r("error");
            return resp.data;
          } catch (e) {
            const blob = new Blob([resp.data], {
              type: 'application/octet-stream,charset="ga2312"'
            });
            const disposition = resp.headers["content-disposition"];
            const tempArr = disposition.split(";");
            const suffixName = window.decodeURI(tempArr[1].split("=")[1]);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              try {
                window.navigator.msSaveOrOpenBlob(blob, fileName || suffixName);
              } catch (e) {
                console.log(e);
              }
            } else {
              let link = document.createElement("a");
              link.href = window.URL.createObjectURL(blob); // 创建下载的链接
              link.download = fileName || suffixName; // 下载后文件名
              link.style.display = "none";
              link.target = "_blank";
              document.body.appendChild(link);
              link.dispatchEvent(
                new MouseEvent("click", {
                  bubbles: true,
                  cancelable: true,
                  view: window
                })
              );
              window.URL.revokeObjectURL(link.href); // 释放掉blob对象
              document.body.removeChild(link); // 下载完成移除元素
            }
            console.log("error");

            r("ok");
          }
        }
      })
      .catch(error => {
        console.log("error");
        j("error");
        // return false;
      });
  });
}

// 白名单sku
export const whiteSku = data => get("api/client/order/white_sku", data);
export const skuDetail = id => get("api/client/order/white_sku_detail/" + id);
export const importWhiteSku = data =>
  post("api/client/order/import_white_sku ", data);
export const addWhiteSku = data => post("api/client/order/white_sku", data);
export const editWhiteSku = data =>
  put("api/client/order/white_sku/" + data.id, data);
export const delWhiteSku = data => del("api/client/order/white_sku", data);

// 地址管理
export const addressList = data => get("api/client/memberAddress", data);
export const addressDetail = id => get("api/client/memberAddress/" + id);
export const addAddress = data => post("api/client/memberAddress", data);
export const editAddress = data =>
  post("api/client/memberAddress/customUpdate", data);
export const delAddress = data => del("api/client/memberAddress", data);
export const default_address = data => get("api/client/order/default_address", data);



// WEBPACK FOOTER //
// ./src/axios/api.js